import {
	WORKING_TIME_SETUP_CREATE_EDIT,
	WORKING_TIME_SETUP_CREATE_EDIT_ERROR,
	WORKING_TIME_SETUP_CREATE_EDIT_SUCCESS,
	WORKING_TIME_SETUP_DETAILS,
	WORKING_TIME_SETUP_DETAILS_ERROR,
	WORKING_TIME_SETUP_DETAILS_SUCCESS,
	WORKING_TIME_SETUP_DELETE,
	WORKING_TIME_SETUP_DELETE_ERROR,
	WORKING_TIME_SETUP_DELETE_SUCCESS,
	WORKING_TIME_SETUPS_LIST,
	WORKING_TIME_SETUPS_LIST_SUCCESS,
	WORKING_TIME_SETUPS_LIST_ERROR
} from "../actions/workingTimeSetups";
import Vue from "vue";
import WorkingTimeSetupsService from '@/services/workingTimeSetups';

const state = {
	status: '',
	workingTimeSetup: {},
	workingTimeSetups: []
};

const getters = {
	getWorkingTimeSetup: state => state.workingTimeSetup,
	isWorkingTimeSetupLoaded: state => !!state.workingTimeSetup.id,
	getWorkingTimeSetups: state => state.workingTimeSetups
};

const actions = {
	[WORKING_TIME_SETUP_CREATE_EDIT]: ({ commit, dispatch }, data) => {
		let requestData = {
			id: data.modalWorkingTimeSetup.id,
			user_id: data.modalWorkingTimeSetup.user_id,

			monday_enabled: data.modalWorkingTimeSetup.monday_enabled,
			monday_start: data.modalWorkingTimeSetup.monday_start,
			monday_end: data.modalWorkingTimeSetup.monday_end,

			tuesday_enabled: data.modalWorkingTimeSetup.tuesday_enabled,
			tuesday_start: data.modalWorkingTimeSetup.tuesday_start,
			tuesday_end: data.modalWorkingTimeSetup.tuesday_end,

			wednesday_enabled: data.modalWorkingTimeSetup.wednesday_enabled,
			wednesday_start: data.modalWorkingTimeSetup.wednesday_start,
			wednesday_end: data.modalWorkingTimeSetup.wednesday_end,

			thursday_enabled: data.modalWorkingTimeSetup.thursday_enabled,
			thursday_start: data.modalWorkingTimeSetup.thursday_start,
			thursday_end: data.modalWorkingTimeSetup.thursday_end,

			friday_enabled: data.modalWorkingTimeSetup.friday_enabled,
			friday_start: data.modalWorkingTimeSetup.friday_start,
			friday_end: data.modalWorkingTimeSetup.friday_end,

			saturday_enabled: data.modalWorkingTimeSetup.saturday_enabled,
			saturday_start: data.modalWorkingTimeSetup.saturday_start,
			saturday_end: data.modalWorkingTimeSetup.saturday_end,

			sunday_enabled: data.modalWorkingTimeSetup.sunday_enabled,
			sunday_start: data.modalWorkingTimeSetup.sunday_start,
			sunday_end: data.modalWorkingTimeSetup.sunday_end,

			holiday_enabled: data.modalWorkingTimeSetup.holiday_enabled,
			holiday_start: data.modalWorkingTimeSetup.holiday_start,
			holiday_end: data.modalWorkingTimeSetup.holiday_end,

			effective_from: data.modalWorkingTimeSetup.effective_from,
			effective_to: data.modalWorkingTimeSetup.effective_to,
			reason: data.modalWorkingTimeSetup.reason
		}
		return new Promise((resolve, reject) => {
			commit(WORKING_TIME_SETUP_CREATE_EDIT);
			WorkingTimeSetupsService.createEdit(requestData).then(responseData => {
				commit(WORKING_TIME_SETUP_CREATE_EDIT_SUCCESS);
				dispatch(WORKING_TIME_SETUP_DETAILS, responseData.workingTimeSetup.id);
				resolve(responseData);
			})
			.catch(error => {
				commit(WORKING_TIME_SETUP_CREATE_EDIT_ERROR, error);
				reject(error);
			});
		});
	},
	[WORKING_TIME_SETUP_DETAILS]: ({ commit, dispatch }, id) => {
		let requestData = {
			id: id,
		}
		return new Promise((resolve, reject) => {
			commit(WORKING_TIME_SETUP_DETAILS);
			WorkingTimeSetupsService.details(requestData)
				.then(data => {
					commit(WORKING_TIME_SETUP_DETAILS_SUCCESS);
					resolve(data);
				})
				.catch(error => {
					commit(WORKING_TIME_SETUP_DETAILS_ERROR, error);
					reject(error);
				});
		});
	},
	[WORKING_TIME_SETUP_DELETE]: ({ commit, dispatch }, id) => {
		let requestData = {
			id: id,
		}
		return new Promise((resolve, reject) => {
			commit(WORKING_TIME_SETUP_DELETE);
			WorkingTimeSetupsService.delete(requestData)
				.then(data => {
					commit(WORKING_TIME_SETUP_DELETE_SUCCESS);
					resolve(data);
				})
				.catch(error => {
					commit(WORKING_TIME_SETUP_DELETE_ERROR, error);
					reject(error);
				});
		});
	},
	[WORKING_TIME_SETUPS_LIST]: ({ commit }, data) => {
		let requestData = {
			perPage: data.tableProps.itemsPerPage,
			page: data.tableProps.currentPage,
			sort: data.ctx.sortBy,
			desc: data.ctx.sortDesc,
		}
		if (data.tableProps.inputFilter.search !== null) {
			requestData.search = data.tableProps.inputFilter.search;
		}
		if (data.tableProps.inputFilter.user_ids !== null) {
			requestData.user_ids = data.tableProps.inputFilter.user_ids;
		}
		if (data.tableProps.inputFilter.start_date !== null && data.tableProps.inputFilter.start_date !== undefined) {
			requestData.start_date = data.tableProps.inputFilter.start_date;
		}
		if (data.tableProps.inputFilter.end_date !== null && data.tableProps.inputFilter.end_date !== undefined) {
			requestData.end_date = data.tableProps.inputFilter.end_date;
		}
		return new Promise((resolve, reject) => {
			commit(WORKING_TIME_SETUPS_LIST);
			WorkingTimeSetupsService.list(requestData)
				.then(data => {
					commit(WORKING_TIME_SETUPS_LIST_SUCCESS, data.workingTimeSetups);
					resolve(data);
				})
				.catch(error => {
					commit(WORKING_TIME_SETUPS_LIST_ERROR, error);
					reject(error);
				});
		});
	}
};

const mutations = {
	[WORKING_TIME_SETUP_CREATE_EDIT]: (state) => {
		state.status = 'loading';
	},
	[WORKING_TIME_SETUP_CREATE_EDIT_SUCCESS]: (state) => {
		state.status = 'success';
	},
	[WORKING_TIME_SETUP_CREATE_EDIT_ERROR]: (state) => {
		state.status = 'error';
	},
	[WORKING_TIME_SETUP_DETAILS]: (state) => {
		state.status = 'loading';
	},
	[WORKING_TIME_SETUP_DETAILS_SUCCESS]: (state, workingTimeSetup) => {
		state.status = 'success';
		Vue.set(state, 'workingTimeSetup', workingTimeSetup);
	},
	[WORKING_TIME_SETUP_DETAILS_ERROR]: (state) => {
		state.status = 'error';
	},
	[WORKING_TIME_SETUP_DELETE]: (state) => {
		state.status = 'loading';
	},
	[WORKING_TIME_SETUP_DELETE_SUCCESS]: (state) => {
		state.status = 'success';
	},
	[WORKING_TIME_SETUP_DELETE_ERROR]: (state) => {
		state.status = 'error';
	},
	[WORKING_TIME_SETUPS_LIST]: (state) => {
		state.status = 'loading';
	},
	[WORKING_TIME_SETUPS_LIST_SUCCESS]: (state, workingTimeSetups) => {
		state.status = 'success';
		Vue.set(state, 'workingTimeSetups', workingTimeSetups);
	},
	[WORKING_TIME_SETUPS_LIST_ERROR]: (state) => {
		state.status = 'error';
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};
